import { flow, types } from 'mobx-state-tree'
import { getPayoutFreqReq } from '../../network/getPayoutFreqReq'
import { updatePayoutFrequencyConfigReq } from '../../network/updatePayoutFrequencyConfigReq'
import { getErrorMessage, MessageTypes } from '../../utils'
import { RootStore } from '../store'

const PayoutFrequency = types.model('PayoutFrequency', {
  id: types.optional(types.number, -1),
  startTime: types.optional(types.string, ''),
  interval: types.optional(types.number, -1),
  description: types.optional(types.string, ''),
})

const PayoutFrequencyConfig = types
  .model('PayoutFrequencyConfig', {
    config: types.array(PayoutFrequency),
  })
  .actions((self) => ({
    fetchPayoutFrequencyConfig: flow(function* fetchPayoutFrequencyConfig(mid: string) {
      try {
        const response = yield getPayoutFreqReq(mid, RootStore.session.getTokens)
        self.config = response?.payoutFrequency
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    updatePayoutFrequencyConfig: flow(function* updatePayoutFrequencyConfig(data: any) {
      try {
        const response = yield updatePayoutFrequencyConfigReq(data, RootStore.session.getTokens)
        if (response.status === 'SUCCESS') {
          RootStore.message.setMessage(response.status, MessageTypes.SUCCESS)
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getAllConfigs() {
      const data = self?.config?.map((item) => {
        return {
          id: item?.id,
          startTime: item?.startTime,
          interval: item?.interval,
          description: item?.description,
        }
      })
      return data
    },
    getAllFrequencies() {
      const sortdedArr = self?.config?.slice()?.sort((a, b) => (a.id > b.id ? 1 : -1))
      const data = sortdedArr?.map((item) => {
        return {
          id: item?.id,
          value: item?.id,
        }
      })
      return data
    },
    getFilteredFreuencyConfigList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.config ?? []
      const data = list?.map((item: any) => {
        return {
          ...item,
          id: `${item.id}`,
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return list?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      }
      return data
    },
  }))

const payoutFrequencyConfigData = PayoutFrequencyConfig.create({
  config: [],
})

export { PayoutFrequencyConfig, payoutFrequencyConfigData }
